import type { FlightLeg } from '../../../domain/types'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Fragment } from 'react'
import { FlightAirlineServices } from './FlightAirlineServices'
import styles from './FlightDetailsCard.module.css'
import { FlightLegDetails } from './FlightLegDetails'
import { FlightLuggage } from './FlightLuggage'
import { FlightStopover } from './FlightStopover'

export interface FlightDetailsCardProps {
  title: string
  subtitle?: string
  legs: FlightLeg[]
  direction: 'outbound' | 'inbound'
  isCancelled: boolean
  showLuggageSection?: boolean
  showAirlineServices?: boolean
}

export function FlightDetailsCard({
  title,
  subtitle,
  legs,
  direction,
  isCancelled,
  showLuggageSection = false,
  showAirlineServices = false,
}: FlightDetailsCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerTop}>
          <Typography as="h3" variant="display-i-regular">
            {title}
          </Typography>
          {subtitle && (
            <Typography as="p" variant="body-s-regular-tight" className={styles.subtitle}>
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      <div className={styles.legs}>
        {legs.map((leg, index, allLegs) => {
          const nextLeg = allLegs[index + 1]

          return (
            <Fragment key={leg.flightNumber || String(index)}>
              <FlightLegDetails leg={leg} direction={direction} isCancelled={isCancelled} />
              {nextLeg && <FlightStopover previousLeg={leg} nextLeg={nextLeg} />}
            </Fragment>
          )
        })}
      </div>
      {showLuggageSection && (
        <FlightLuggage legs={legs} />
      )}
      {showAirlineServices && <FlightAirlineServices legs={legs} />}
    </div>
  )
}
